import React from "react";

export default function BackButton({
  currentScreen,
  setCurrentScreen,
  emuJSON,
}) {
  return (
    <>
      <button
        onClick={() => {
          if (emuJSON[currentScreen].prev_screen) {
            setCurrentScreen(emuJSON[currentScreen].prev_screen);
          } else {
            setCurrentScreen("images/screens/001.jpg");
          }
        }}
        className="emulator-button"
        style={{
          top: 387,
          left: 25,
          height: "26px",
          width: "38px",
          borderRadius: "15px",
        }}
      ></button>
    </>
  );
}
